import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter, namespace } from 'vuex-class';
import _sortBy from 'lodash/sortBy';
import _debounce from 'lodash/debounce';
// import { deepClone } from 'fast-json-patch/lib/core';

import { TabViewModel } from '../../models/common/tab-view.model';
import { storeModules } from '../../store';
import { TAB_VIEW_GETTERS, TAB_VIEW_ACTIONS } from '../../store/tab-view/tab-view-types.store';
// import { ROUTER } from '../../common/constants';
import EventBus from '../../utils/event-bus';
import { EVENT_BUS, PAGE_VIEW_TYPES, ROUTER } from '../../common/constants';
import { LocalforageWrapper } from '../../utils/localforage-wrapper';
import { findTabViewHandler } from '../../utils/util';
import moduleType from '../../common/module-constant';
import EventTracker from '../../utils/event-tracker';
import { TRACKING_EVENTS } from '../../common/tracking-event.constants';

const TabViewGetter = namespace(storeModules.TabView, Getter);
const TabViewAction = namespace(storeModules.TabView, Action);

const EDIT_ROUTE_NAME_BY_MODULE_TYPE = {
  [moduleType.Object]: ROUTER.PROPERTY.PROPERTY_EDIT,
  [moduleType.Project]: ROUTER.PROJECT.PROJECT_EDIT,
  [moduleType.Person]: ROUTER.CLIENT.CLIENT_EDIT,
  [moduleType.Demand]: ROUTER.DEMAND.DEMAND_EDIT,
  [moduleType.Task]: ROUTER.TASK.TASK_EDIT,
}

// const PERSISTENT_TABS = {
//   'property': ROUTER.PROPERTY.PROPERTY,
//   'project': ROUTER.PROPERTY.PROPERTY,
//   'demand': ROUTER.DEMAND.DEMAND,
//   'client': ROUTER.CLIENT.CLIENT,
//   'task': ROUTER.TASK.TASK,
//   'agenda': ROUTER.AGENDA.AGENDA
// }

const MAX_DISPLAY_TAB_DEFAULT = 1
const CONTEXT_MENU_OPTIONS = {
    CLOSE_ME: 0,
    CLOSE_OTHERS: 1,
    CLOSE_RIGHT: 2,
    CLOSE_ALL: 3,
}
@Component({
  name: 'TabComponent',
  template: require('./template.html'),
  components: {
    'tab-label': () => import('./TabTitle.vue'),
    'tab-icon': () => import('./TabIcon.vue')
  }
})

export default class TabComponent extends Vue {
  @TabViewGetter(TAB_VIEW_GETTERS.GET_TAB_VIEWS) tabViews: Array<TabViewModel>;
  @TabViewGetter(TAB_VIEW_GETTERS.ACTIVE_TAB_PATH) storeActiveTabPath: string;
  @TabViewGetter(TAB_VIEW_GETTERS.ACTIVE_TAB) activeTab: TabViewModel;
  @TabViewAction(TAB_VIEW_ACTIONS.ADD_TAB) addTab;
  @TabViewAction(TAB_VIEW_ACTIONS.REMOVE_TAB) removeTabStore;
  @TabViewAction(TAB_VIEW_ACTIONS.SET_TAB_VIEWS) setTabViews;
  @TabViewAction(TAB_VIEW_ACTIONS.UPDATE_TABVIEW_ORDER) private storeUpdateTabViewOrder : (value: Array<TabViewModel>) => void;
  @TabViewAction(TAB_VIEW_ACTIONS.UPDATE_OLD_TAB) updateOldTab;

  maxDisplayTab: number = MAX_DISPLAY_TAB_DEFAULT;
  shouldGroupTab: boolean = window.innerWidth > 1024 ? false : true;
  localizeLoaded: boolean = false;
  activeTabPath: string = '';
  private activeContextMenuTabIndex: number = -1;
  private closeMultitpleTabProcess: any = null;

  private isTabSwitching: boolean = false;
  private pendingTabSwitch: TabViewModel | null = null;
  private debouncedTabSwitch: Function;

  visibleTabs() {
    return this.tabViews.slice(0, this.maxDisplayTab);
  }

  get hiddenTabs() {
    return this.tabViews.slice(this.maxDisplayTab, this.tabViews.length);
  }

  get isMoreTabActive() {
    return this.hiddenTabs.findIndex(item => item.url === this.activeTabPath) > -1
  }

  get dragTabViews() {
    return this.tabViews
  }

  set dragTabViews(value) {
    console.log('value: ', value);
    this.storeUpdateTabViewOrder(value);
  }

  get showTabLoading(): boolean {
    return this.isTabSwitching && !!this.pendingTabSwitch;
  }

  created() {
    this.debouncedTabSwitch = _debounce(this.actualTabSwitch, 300);
  }

  beforeDestroy() {
    if (this.debouncedTabSwitch) {
      (this.debouncedTabSwitch as any).cancel();
    }
  }

  handleTabClick(tab: TabViewModel): void {
    if (tab.url === this.activeTabPath) {
      return;
    }

    this.isTabSwitching = true;
    this.pendingTabSwitch = tab;

    this.debouncedTabSwitch(tab);
  }

  private actualTabSwitch(tab: TabViewModel): void {
    try {
      // Navigate to the tab
      this.$router.push(this.getRouterLink(tab));

      // Track the event
      EventTracker.logEvent({
        FormName: TRACKING_EVENTS.PAGES.GLOBAL,
        Action: TRACKING_EVENTS.EVENTS.TABVIEW_CHANGE_TAB,
        FormId: 0,
        Comment: { newPath: tab.url }
      });

    } catch (error) {
      console.error('Error switching tab:', error);
    } finally {
      setTimeout(() => {
        this.isTabSwitching = false;
        this.pendingTabSwitch = null;
      }, 300);
    }
  }

  getRouterLink(tab: TabViewModel) {
    return {
      path: tab.url,
      query: tab.query ? tab.query : {}
    };
  }

  private buildTabViewByRoute(route) {
    const tabView = new TabViewModel({
      title: route.meta.title_key,
      icon: route.meta.icon_name,
      identifyData: {
        name: route.name,
        id: route.params.id,
        moduleType: route.meta.moduleType,
        viewType: route.meta.viewType
      },
      url: route.path,
      query: route.query,
      persistent: route.meta.persistent || false,
      meta: route.meta
    })
    console.log('tab: ', tabView)
    return tabView;
  }

  // private setPersistentTab() {
  //   const persistentTab = this.tabViews.find((item: TabViewModel) => item.persistent);
  //   if (!persistentTab) {
  //     const routeType = this.$route.path.split('/')[1];
  //     const persistentTabName = PERSISTENT_TABS[routeType];
  //     if (persistentTabName) {
  //       const persistentRoute = (this.$router as any).options.routes.find(route => route.name === persistentTabName);
  //       if (persistentRoute) {
  //         persistentRoute.meta = persistentRoute.meta || {};
  //         persistentRoute.params = persistentRoute.params || {};
  //         this.setTabView(persistentRoute, false);
  //       }
  //     }
  //   }
  // }

  private verifyActiveEditTab(newTab: TabViewModel, forceView: boolean) {
    // If open view object and it is not force option while exist edit tab => should link to edit page.
    if (!forceView && newTab.identifyData.viewType === PAGE_VIEW_TYPES.DETAIL) {
      let sameObjectEditTabIndex = this.tabViews.findIndex((item: TabViewModel) => {
        return  item.identifyData.moduleType === newTab.identifyData.moduleType
        && item.identifyData.viewType === PAGE_VIEW_TYPES.EDIT
        && item.identifyData.id == newTab.identifyData.id;
      });
      if (sameObjectEditTabIndex > -1) {
        this.$router.push({
          name: EDIT_ROUTE_NAME_BY_MODULE_TYPE[newTab.identifyData.moduleType],
          params: {
            id: newTab.identifyData.id.toString()
          }
        })
        return true;
      }
    }
    return false;
  }

  setTabView(route, setActive) {
    if (route.path === '/' || route.name === 'pageNotFound') return;
    const newTab = this.buildTabViewByRoute(route);
    const forceView = route.params.forceView === 'true' ? true : false
    const shouldActiveEditTab = this.verifyActiveEditTab(newTab, forceView);
    if (!shouldActiveEditTab) {
      this.addTab({
        tab: newTab,
        setActive: setActive
      });

    setTimeout(() => {
      const refs = this.$refs[`tabItem${route.path}`] as any;
      if(refs && refs.length) {
          refs[0].scrollIntoView({behavior: 'smooth', block: 'center'})
      }
    }, 300)
    }
  }

  removeTab(tab: TabViewModel) {
    // todo: Will check confirmAction
    EventTracker.logEvent({
        FormName: TRACKING_EVENTS.PAGES.GLOBAL,
        Action: TRACKING_EVENTS.EVENTS.TABVIEW_REMOVE_TAB,
        FormId: 0,
        Comment: tab
    })

    // Keep initial width of dropdown menu
    const dropMenu = this.$refs.tabViewMoreMenu as HTMLElement;
    if (dropMenu) {
      const width = dropMenu.clientWidth;
      dropMenu.style.minWidth = width + "px";
    }

    const tabIsActive = findTabViewHandler(tab, this.activeTab);

    if (tab.callBackClearMemory && typeof tab.callBackClearMemory === 'function') {
      tab.callBackClearMemory();
    }

    if (tabIsActive) {
      console.log(tab);
      
      if (tab.callbackClose && typeof tab.callbackClose === 'function') {
        return tab.callbackClose();
      }
      this.handleRemoveAndBackTab(tab);
    } else {
      if (tab.unSavedData) {
        this.$router.push({ path: tab.url, query: { ...tab.query, closeable: '1' } });
      } else {
        this.removeTabFormStore(tab);
      }
    }
    this.notifyCloseAppointmentTab(tab);
  }

  visibleChange(value) {
    // Clean kept width of dropdown menu
    if (value === false) {
      const dropMenu = this.$refs.tabViewMoreMenu as HTMLElement;
      if (dropMenu) {
        dropMenu.style.minWidth = "";
      }
    }
  }

  private removeTabFormStore(tab) {
    this.removeTabStore(tab);
    if(this.closeMultitpleTabProcess) {
      this.handleCloseMultipleTab();
    }
  }

  private notifyCloseAppointmentTab(tab: TabViewModel) {
    if (tab.identifyData.moduleType === moduleType.Agenda
      && tab.identifyData.viewType === PAGE_VIEW_TYPES.EDIT) {
        this.$root.$emit('close-appointment-edit-tab', tab.identifyData.id);
    }
  }
  private handleBackTab(tabIndex: number) {
    if (tabIndex > 0) {
      this.updateOldTab(this.tabViews[tabIndex]);
      const activeTab = this.tabViews[tabIndex - 1];
      // todo: append all query to path
      this.$router.push({ path: activeTab.url, query: { ...activeTab.query } });
    } else {
      if (this.tabViews.length > 1) {
        this.$router.push({ path: this.tabViews[1].url, query: { ...this.tabViews[1].query } });
      } else {
        this.$router.push({path: '/agenda'});
      }
    }
  }
  handleRemoveAndBackTab(tab: TabViewModel) {
    const tabIndex = this.tabViews.findIndex((item: TabViewModel) => {
      return findTabViewHandler(item, tab);
    })
    if (!this.closeMultitpleTabProcess) {
      this.handleBackTab(tabIndex);
    }
    this.removeTabFormStore(tab);
    this.notifyCloseAppointmentTab(tab);
  }

  checkShowWarning() {
    const unSaved = this.tabViews.filter(element => element.unSavedData);
    if (unSaved.length > 0) return true;
    return false;
  }

  private async getTabViews() {
    let tabViews = await LocalforageWrapper.getItem('Tab_views') as any;
    return tabViews;
  }

  onRightClickTabView(event, tab, index) {
    if (this.activeContextMenuTabIndex === index) return;
    this.activeContextMenuTabIndex = index;
  }

  onClickOutsideContextmenu() {
    setTimeout(() => {
      this.activeContextMenuTabIndex = -1;
    }, 100);
  }

  handleClickOnContextMenu(tab, contextOption) {
    console.log('handleClickOnContextMenu: ', tab);
    this.activeContextMenuTabIndex = -1;
    switch(contextOption) {
      case CONTEXT_MENU_OPTIONS.CLOSE_ME:
        this.removeTab(tab);
        break;
      case CONTEXT_MENU_OPTIONS.CLOSE_OTHERS: {
        let otherTabs = this.tabViews.filter(item => {
          return !findTabViewHandler(item, tab);
        })
        if (otherTabs.length === 0) return;
        otherTabs = _sortBy(otherTabs, (item: TabViewModel) => item.unSavedData ? -1 : 1);
        const activeTab = { path: tab.url, query: { ...tab.query } }
        this.closeMultitpleTabProcess = this.closeMultipleTabGenerator(otherTabs, activeTab);
        this.handleCloseMultipleTab();
        break;
      }
      case CONTEXT_MENU_OPTIONS.CLOSE_RIGHT: {
        let tabIndex = this.tabViews.findIndex(item => {
          return findTabViewHandler(item, tab);
        })
        if (tabIndex > -1) {
          let rightTabs = this.tabViews.slice(tabIndex + 1, this.tabViews.length);
          if (rightTabs.length === 0) return;
          rightTabs = _sortBy(rightTabs, (item: TabViewModel) => item.unSavedData ? -1 : 1);
          const activeTabIndex = this.tabViews.findIndex(item => {
            return findTabViewHandler(item, this.activeTab);
          })
          const activeTab = activeTabIndex > tabIndex
            ? { path: tab.url, query: { ...tab.query } }
            : { path: this.activeTab.url, query: {...this.activeTab.query}};
          this.closeMultitpleTabProcess = this.closeMultipleTabGenerator(rightTabs, activeTab);
          this.handleCloseMultipleTab();
        }
        
        break;
      }
      case CONTEXT_MENU_OPTIONS.CLOSE_ALL:
        const agendaTab = {
          identifyData: {
            name: ROUTER.AGENDA.AGENDA
          }
        }
        let allRemoveTabs = this.tabViews.filter(tab => {
          return !findTabViewHandler(tab, agendaTab);
        })
        allRemoveTabs = _sortBy(allRemoveTabs, (item: TabViewModel) => item.unSavedData ? -1: 1);
        const backRoute = {path: '/agenda'}
        this.closeMultitpleTabProcess = this.closeMultipleTabGenerator(allRemoveTabs, backRoute);
        this.handleCloseMultipleTab();
        break;
    }
      EventTracker.logEvent({
          FormName: TRACKING_EVENTS.PAGES.GLOBAL,
          Action: TRACKING_EVENTS.EVENTS.TABVIEW_SELECT_CONTEXT_MENU,
          FormId: 0,
          Comment: { option: contextOption }
      })
  }

  private *closeMultipleTabGenerator(tabs, backRoute?) {
    for (let index = 0; index < tabs.length; index ++) {
      console.log('closeMultipleTabGenerator: ', index);
      setTimeout(() => {
        this.removeTab(tabs[index]);
      })
      yield true;
    }
    if (backRoute) {
      this.$router.push(backRoute);
    }
    yield false;
  }

  private handleCloseMultipleTab() {
    const inProcess = this.closeMultitpleTabProcess.next().value;
    if (!inProcess) this.closeMultitpleTabProcess = null;
    console.log('handleCloseMultipleTab: ', inProcess);
  }

  @Watch('storeActiveTabPath')
  onChangeStoreActiveTabPath(newVal) {
    this.activeTabPath = newVal;
  }

  @Watch('$route')
  onChangeRoute(newVal) {
    this.activeTabPath = newVal.path;
    console.log('onChangeRoute: ', newVal)
    this.setTabView(newVal, true);
    
    if (!this.isTabSwitching) {
      EventTracker.logEvent({
          FormName: TRACKING_EVENTS.PAGES.GLOBAL,
          Action: TRACKING_EVENTS.EVENTS.TABVIEW_CHANGE_TAB,
          FormId: 0,
          Comment: { newPath: newVal.path}
      })
    }
  }

  async mounted() {
    const tabviews = await this.getTabViews();
    if (tabviews) {
      this.setTabViews(tabviews);
    }
    this.setTabView(this.$route, true);
    // setTimeout(() => {
    //   this.setPersistentTab();
    // }, 2000);
    EventBus.$on(EVENT_BUS.COMMON.LOADED_TRANSALTED, () => {
      this.localizeLoaded = true;
      this.$forceUpdate()
    });
    EventBus.$on('close-tab-view', (data) => {
      this.handleRemoveAndBackTab(data);
    });

    EventBus.$on('close-tab-only', (data) => {
      this.removeTabFormStore(data);
    });

    EventBus.$on('cancel-close-tab', (data) => {
      if (this.closeMultitpleTabProcess) this.closeMultitpleTabProcess = null;
    });

    window.onbeforeunload = () => {
      if (this.checkShowWarning()) {
        return "";
      }
    }
  }
}
